import { Avatar } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(3),
  height: theme.spacing(3),
}));

export default SmallAvatar;
